import { createSlice } from '@reduxjs/toolkit';
import { IInitialState, IAction } from './type';
import { IOrganization } from '../../../types';

const initialState: IInitialState = {
  organizations: [],
};

const setOrganizations = (
  state: IInitialState,
  action: IAction<IOrganization[]>,
) => {
  state.organizations = action.payload;
};

const clearOrganizations = (state: IInitialState) => {
  state.organizations = [];
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganizations,
    clearOrganizations,
  },
});

export const organizationActions = organizationSlice.actions;
const organizationReducer = organizationSlice.reducer;
export default organizationReducer;
